import utils from '@eitje/utils'

export const formatSector = sector => utils.capitalize(sector).replace('Ij', 'IJ')
